/**
 *
 * @module adobeIdentityClientConfiguration
 *
 */

import ServiceClientConfiguration from './../../configuration/serviceClientConfiguration';

/**
 *
 * @class AdobeIdentityClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the AdobeIdentityClient.
 *
 */
export default class AdobeIdentityClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/identity/adobe/adobeIdentityClientConfiguration.js